

















import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';

import {Notify} from '@/utils/Notify';

import {CertificateDetails} from '@/model/system/certificate/certificateDetails';

import {ISystemCertificateService} from '@/services/system/ICertificate.service';

import {BaseComponent} from '@/mixins/BaseComponent';
import CertificateInformation from '@/components/System/Certificate/CertificateInformation.vue';
import CertificateChange from '@/components/System/Certificate/CertificateChange.vue';

@Component({
  components: {CertificateChange, CertificateInformation},
})
export default class Certificate extends Mixins<BaseComponent>(BaseComponent) {

  @Inject(Symbol.for('ISystemCertificateService'))
  private systemCertificateService!: ISystemCertificateService;

  /* Certificate details */
  private certificateDetails: CertificateDetails | null = null;

  private async mounted() {
    this.setLoading();
    try {
      this.certificateDetails = await this.systemCertificateService.getDetails();
      this.logger.info('Certificate details fetched', this.certificateDetails);
    } catch (error) {
      Notify.Error(this.logger, `Could not get certificate details`, error);
    } finally {
      this.setLoaded();
    }
  }
}
